/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function n(n, r, u) {
  return !!t(n, r, u);
}
function r(n, r, u) {
  return t(n, r, u);
}
function t(n, r, t) {
  return n && n.hasOwnProperty(r) ? n[r] : t;
}
export { n as readBoolean, r as readNumber, t as readValue };